import React from "react";
import Sidebar from "../../components/commons/Sidebar";
import ClientTable from "../../components/admin/client/client";

const ClientsAdminPage = () => {
  return (
    <div className="flex flex-col md:flex-row min-h-screen bg-slate-50">
      <Sidebar />
      <ClientTable />
    </div>
  );
};

export default ClientsAdminPage;
